import { Row } from 'react-bootstrap'
import styled, { css } from 'styled-components'

const v4 = css`
  --button-height: 46px;
  .panel-heading {
    padding: 20px 0;

    a {
        display: flex;
        justify-content: space-between;
        padding: 10px 0px 5px 10px;
        font-weight: 700;

        &:before {
            display: none !important;
        }
    }
  }
  h1 {
    font-weight: 700;
    color: var(--clr-black-to-white);
  }
  h5 {
    padding-top: 0px;
    font-weight: 400;
    color: var(--clr-grey-4-to-white);
  }
`
const v4Specs = css`
  .small-column {
    button {
      background-color: transparent;
      color: var(--clr-btn);
      width: 220px;
      border: 2px solid var(--clr-btn);
      height: var(--button-height);
      text-transform: lowercase;
      font-weight: 700;
    }
  }
`

export const Wrapper = styled.div`
  margin-top: 15px;
  padding: 0;
  .panel-default {
    border: none;
    margin: 0;
    box-shadow: none;
  }
  .panel-heading {
    background: none;
    cursor: pointer;
    border: none;
    padding: 20px;
  }
  .panel-heading a {
    display: 'inline-block';
    width: 100%;
    text-decoration: none !important;
    font-size: var(--h5);
    color: var(--clr-grey-4-to-white);
    position: relative;
    padding: 10px 0px 5px 20px;
    cursor: pointer;
    font-weight: 400;
    transition: transform 500ms ease;

    &:before {
      color: var(--clr-accent);
    }
  }
  .panel-heading a > img {
    transition: all 500ms ease;
  }
  .panel-heading a.collapsed > img {
    transform: rotate(-90deg);
  }
  .panel-body {
    color: var(--clr-grey-3-to-white);
    padding: 5px 15px;
  }
  .panel-default {
    background-color: var(--clr-bg);
  }
  .specs-content {
    color: var(--clr-grey-3-to-text);
  }
  h1 {
    margin-top: 0px;
    margin-bottom: 25px;
    color: var(--clr-grey-4-to-white);
    font-size: var(--h5);
  }
  a {
    color: var(--clr-accent-to-grey-0);
    text-decoration: none;
  }
  h5 {
    padding-top: 50px;
    font-weight: 700;
  }
  button {
    margin: 25px auto 10px;
    color: var(--clr-black-to-main);
    background-color: var(--clr-btn);
    font-size: 1.15em;
    transition: 0.3s background-color;
    padding-left: 0;
    padding-right: 0;
    border: 0;
    display: block;
    border-radius: var(--button-border-radius);
  }
  button:hover {
    background-color: shadeColor(var(--clr-btn), -30);
  }
  button:focus {
    outline: 0;
  }
  ul {
    padding-left: 20px;
    margin: 0;
    overflow: hidden;
    padding-bottom: 25px;
  }
  li {
    color: var(--clr-accent);
    float: left;
    margin: 5px 0;
    padding-right: 25px;
  }
  .spec-li span {
    color: var(--clr-grey-3-to-text);
    font-size: var(--h6);
  }
  .double li {
    width: 50%;
  }
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    overflow: hidden;
    max-width: 100%;
    height: auto;
    margin-bottom: 25px;
  }
  .embed-container iframe,
  .embed-container object,
  .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
  @media (max-width: 992px) {
    .panel-body {
      padding: 5px 0;
    }
  }
  @media (max-width: 991px) {
    .specs-content {
      margin-top: 25px;
    }
  }
  @media (min-width: 992px) {
    .specs-content {
      margin-top: 30px;
    }
  }
  ${props => props.version === 'v4' && v4};
  `
export const SpecsWrapper = styled(Row)`
  .small-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 226px;
      max-height: 452px;
    }
    button {
      margin-top: var(--3xl);
      margin-bottom: 25px;
      display: block;
      background-color: var(--clr-btn);
      color: var(--clr-text-on-button);
      width: 220px;
      height: var(--button-height);
      font-size: 20px;
      font-weight: 700;
    }
  }
  ${props => props.version === 'v4' && v4Specs};
`



// WEBPACK FOOTER //
// ./src/components/Specs/styles.js